
import { Placement } from '@post-office/placements-frontend/rovo-chat-long-running-task-spotlight';
export default Placement;
